<template>
	<div>
		<nio-header-nav position="fixed" leftButton="close" @back="handleBack" :is-white="true" />
		<div id="purchaseAgreement"></div>
	</div>
</template>
<script>
import nativeHybrid from '@/util/nativeHybrid'
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
import axios from 'axios'
export default {
	name: 'App',
	data() {
		return {
			pdfh5: null
		}
	},
	mounted() {
		axios
			.get('https://static.nio.com/fx-static/second-hand-app-pkg/fixed/carPurchaseAgreement.pdf', {
				responseType: 'arraybuffer'
			})
			.then(res => {
				this.pdfh5 = new Pdfh5('#purchaseAgreement', {
					data: res.data
				})
			})
	},
	methods: {
		handleBack() {
			nativeHybrid.closeSyn()
		}
	}
}
</script>

<style>
#purchaseAgreement {
	height: 100vh;
	margin-top: 100px;
}
</style>
